import type React from "react";

import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import { getResetPasswordLink } from "utils/misc/getResetPasswordLink";

interface Props {
  email?: string;
}

export const ForgotPasswordLink: React.FC<Props> = ({ email }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Typography
      variant="subtitle1"
      component="a"
      href={getResetPasswordLink(email)}
      target="_blank"
      rel="noreferrer"
      color={theme.colors.redesign.db60}
    >
      {t("login.reset_password")}
    </Typography>
  );
};
